import React, { FC, useEffect, useCallback, Fragment } from "react";
import { withStyles, WithStyles, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { Box,Typography } from '@material-ui/core';
import uuid from "uuid/v4";
import { fetchHomeScreen, fetchFileDownLoadRequest } from "../redux/actions";
import { validateObject } from "../../../utils/helpers";
import { styles } from "../assets/styles";
import Button from "../../common/layout/Button";
import TitlePage from "../../common/layout/TitlePage";
import Progress from "./../../common/layout/Progress";
import clearConstructorCache from "../../../utils/helpers/clearConstructorCache";
import moment from 'moment';
import reducer, { logoutFlow as saga, loadTokenLogout } from "@mochi/misc/auth/logout/redux";
import { injectSaga } from "@mochi/core";
import { injectReducer } from "@mochi/misc";
import UploadFileButton from '../../common/button/UploadFileButton';
import FreeDialLogo from '../../../assets/images/FreeDialLogo.gif';

interface IProps extends WithStyles<typeof styles> {
  history?: any;
  homeScreen?: any;
  fetchHomeScreen?: any;
  location?: any;
  loadTokenLogout?: any;
  fetchFileDownLoadRequest?: any,
  getFile?: any
}

const HomeScreen: FC<IProps> = ({ location, classes, history, homeScreen, fetchHomeScreen, loadTokenLogout, fetchFileDownLoadRequest, getFile }) => {
  const { pathname } = location;
  localStorage.setItem('ResidentAccessUrl', pathname);

  const getTokenRequest = useCallback(() => {
    const getUUID = uuid();
    const params = {
      mode: "MODE_CREATE_ANONYMOUS_TOKEN",
      param: {
        tenantId: {
          content: "1"
        },
        uuid: {
          content: getUUID
        }
      }
    };

    fetchHomeScreen({ params, getUUID, pathname });
  }, [fetchHomeScreen, pathname])

  useEffect(() => {
    injectReducer("logoutApiToken", reducer);
    injectSaga("logoutSaga", saga);
    loadTokenLogout();
    clearConstructorCache();
    getTokenRequest();
  }, [getTokenRequest, loadTokenLogout]);

  const handleClickButton = path => () => history.push(path);
  const compareReserveEndDate = date => moment().format("YYYY-MM-DD") > moment(date).format("YYYY-MM-DD");
  const { workSubject, workName } = (validateObject.get(homeScreen, 'data') || "");

  const ShowDataInfo = () => {
    return (
      <Grid item xs={12} className={classes.displayMobile}>

        <div className={classes.buildingInfo}>
          <p className={classes.textInfo} style={{fontSize: 28, textAlign: 'center' }}>{workName}</p>
          <p className={classes.textInfo}>各住戸の工事日程・時間帯（午前・午後）を</p>
          <p className={classes.textInfo}>予約 及び 変更することができます。</p>
          <p className={classes.textInfo}>各住戸の工事工程表（案）は事前にお配りしました「工事のご案内」をご参照ください。</p>
        </div>
      </Grid>
    )
  }

  const ShowTextError = () => {
    const { reserveEndDate } = homeScreen.data;
    const currentDate = new Date();
    const reserveEndDateFm = moment(reserveEndDate).format('YYYY-MM-DD');
    const currentDateFm = moment(currentDate).format('YYYY-MM-DD');

    if (reserveEndDateFm <= currentDateFm) {
      return (
        <Grid item xs={12} className={classes.displayMobile} style={{ display: compareReserveEndDate(validateObject.get(homeScreen, 'data.reserveEndDate')) ? 'flex' : 'none' }}>
          <div className={classes.erorInfo}>
            <Typography paragraph={false}>予約締め切り日を過ぎてしまいました。予約したい場合、下記までご連絡ください。</Typography><br/>
            <Typography paragraph={false}>
              <img src={FreeDialLogo} alt="FreeDialLogo" style={{float:'left',width:40}}/>
              <a href="tel:0120936317" className={classes.erorPhone}>0120-936-317</a>
            </Typography>
            <Typography paragraph={false} style={{clear:'both'}}>
              携帯電話からは、<a href="tel:0336211061" className={classes.erorPhone}>03-3621-1061</a>
            </Typography>
            <Typography paragraph={false}>受付時間　午前9時～午後5時</Typography>
            <Typography paragraph={false}>土・日・祝日はお休みとさせていただきます。</Typography>
          </div>
        </Grid>
      )
    }
    return null
  }


  const handleDownloadFile = () => {
    fetchFileDownLoadRequest(history)
  }

  return (
    <Fragment>
      <Progress status={homeScreen.status} />

      {!homeScreen.status && (
        <Fragment>
          <TitlePage label={workSubject} />
          <Grid container className={classes.root}>
            <ShowDataInfo />

            <Grid item xs={12} className={classes.displayMobile}>
              <Button
                onClick={handleClickButton(`/privacy${location.search}`)}
                className={classes.firstBooking}
                disabled={compareReserveEndDate(validateObject.get(homeScreen, 'data.reserveEndDate'))}>
                初めて予約される方
              </Button>
            </Grid>

            <ShowTextError />

            <Grid item xs={12} className={classes.displayMobile}>
              <Button
                color="secondary"
                onClick={handleClickButton(`/login-booking-number${location.search}`)}
                className={classes.changeBooking}
              >
                予約の変更
            </Button>
            </Grid>
            <Grid item xs={12} className={classes.displayMobile}>
              <div className={classes.boxContact2}>
                <p className={classes.textContact}>電話でのご予約を希望される方は<br/>下記までご連絡ください。</p>
                <br/>
                <div>
                  <img src={FreeDialLogo} alt="logo" style={{float:'left',width:40}} />
                  <a href="tel:0120936317" className={classes.textPhone}>0120-936-317</a><br/>
                  携帯電話からは、<a href="tel:0336211061" className={classes.textPhone}>03-3621-1061</a><br/>
                  受付時間　午前9時～午後5時<br/>
                  土・日・祝日はお休みとさせていただきます。
                </div>
              </div>
            </Grid>
            <Grid item xs={12} style={{ maxWidth: 348, margin: '0 auto' }}>
              <UploadFileButton onClick={handleDownloadFile} />
            </Grid>
          </Grid>
        </Fragment>
      )}

    </Fragment>
  );
};

export const mapStateToProps = state => ({
  homeScreen: state.homeScreen,
  getFile: state.homeScreen.file
});

export const mapDispatchToProps = {
  fetchHomeScreen,
  loadTokenLogout,
  fetchFileDownLoadRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HomeScreen));
